module.exports = __webpack_public_path__ + "static/img/555-1.e82fc40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/555-1.svg
// module id = QN3E
// module chunks = 0